import { Mem } from 'src/api/learningSessions/types';

/**
 * MEME `visibility` enum values. The API sends these lowercase.
 * Mems written before the column existed omit the field (`null`).
 */
export const MEM_VISIBILITY = {
  memrise: 'memrise',
  private: 'private',
  public: 'public',
} as const;

const normalise = (value?: string | null) =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

/** Official Memrise-authored mems. Matches `visibility: "memrise"`. */
export const hasMemriseVisibility = (mem: Mem) =>
  normalise(mem.visibility) === MEM_VISIBILITY.memrise;

/**
 * Official Memrise mems: tagged `memrise`, or legacy mems with no creator
 * from before the visibility column existed.
 */
export const isMemriseMem = (mem: Mem) => hasMemriseVisibility(mem) || mem.creatorId === null;

export const isOwnMem = (mem: Mem, currentUserId: number | null) =>
  currentUserId !== null && mem.creatorId === currentUserId;

/**
 * Shown when the Mems toggle is on: official Memrise mems, plus the learner's
 * own. Community `public` mems stay hidden.
 */
export const isAlwaysShownMem = (mem: Mem, currentUserId: number | null) =>
  isMemriseMem(mem) || isOwnMem(mem, currentUserId);

/**
 * Own mems first, then official `memrise` mems, then untagged legacy Memrise
 * mems, then everything else.
 */
export const memSortPriority = (mem: Mem, currentUserId: number | null) => {
  if (isOwnMem(mem, currentUserId)) return 0;
  if (hasMemriseVisibility(mem)) return 1;
  if (mem.creatorId === null) return 2;
  return 3;
};
